import BigNumber from 'bignumber.js'
import { BUYBACK_FEE } from 'config/constants/info'
import { getUnixTime, add } from 'date-fns'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import { useFetchVVSBarHistory } from 'state/info/queries/bar/barHistory'
import { useFetchVvsDayData } from 'state/info/queries/protocol/chart'
import useXvvsRate from './useXvvsRate'

export default function usePastWeekApr() {
  const price = usePriceVvsUsdc()

  const { data: vvsDayData } = useFetchVvsDayData(getUnixTime(add(new Date(), { days: -7 })))
  const { data, error } = useFetchVVSBarHistory(getUnixTime(add(new Date(), { days: -7 })))
  const rate = useXvvsRate()

  if (rate.equalTo('1')) {
    return 0
  }

  const { aprs }: { aprs: { date: number; value: number }[] } =
    !error && data?.barDailySnapshots && vvsDayData
      ? data.barDailySnapshots.reduce(
          (previousValue, currentValue) => {
            const date = parseInt(currentValue.date) * 1000
            const dayData = vvsDayData.find((d) => d.date === parseInt(currentValue.date))
            // FIXME: handle data not enough for 7 days, exclude day 1 data
            if (dayData && date > 1648080000000) {
              const apr =
                (((dayData?.volumeUSD * BUYBACK_FEE) / new BigNumber(currentValue.totalSupply).toNumber()) * 365) /
                new BigNumber(currentValue.ratio).times(price).toNumber()
              previousValue.aprs.push({
                date,
                value: apr * 100,
              })
            }
            return previousValue
          },
          {
            aprs: [],
          },
        )
      : { aprs: [] }

  return (
    aprs
      .filter((x) => x.value !== Infinity)
      .map((x) => x.value)
      .reduce((prev, curr) => prev + curr, 0) / aprs.filter((x) => x.value !== Infinity).length
  )
}
